import { Colors, Icon, Pills } from '@amelio/ui-library';

import type { ResultsStatus } from './belowThresholdState';

import { useAmelioTranslations } from '@/hooks';

interface ResultsStatePillProps {
    status: ResultsStatus;
}

/** A feedback that stopped collecting says so in its header. */
export const ResultsStatePill = ({ status: { kind, date } }: ResultsStatePillProps) => {
    const { t } = useAmelioTranslations();

    const closedLabel = date
        ? t('results.belowThreshold.closedOn', { date })
        : t('results.belowThreshold.closed');
    const completedLabel = date ? t('results.completedOn', { date }) : t('results.completed');

    return (
        <Pills
            variant={'default'}
            size={'sm'}
            dataTestId={'results-state'}
        >
            <Icon
                name={'time-calendar'}
                size={'sm'}
                color={Colors.BASE_400}
                ariaHidden
            />

            {kind === 'completed' ? completedLabel : closedLabel}
        </Pills>
    );
};
